/**
 * @typedef {string} ElementSize
 *
 * This is a size supported by the elements
 */

export const none = "none";

export const small = "small";

export const medium = "medium";

export const large = "large";

export const extraLarge = "extra-large";

/**
 * Helper function that builds a size CSS class, and prepend the given prefix to it.
 *
 * @param {string} prefix - Help discriminate the CSS class
 * @param {ElementSize} size - Size object to use to build the CSS class
 * @return {string}
 */
export function elementSizeCssClass(prefix, size) {
	switch (size) {
		case none: {
			return `${prefix}-${none}`;
		}
		case small: {
			return `${prefix}-${small}`;
		}
		case medium: {
			return `${prefix}-${medium}`;
		}
		case large: {
			return `${prefix}-${large}`;
		}
		case extraLarge: {
			return `${prefix}-${extraLarge}`;
		}
		default: {
			return "";
		}
	}
}
